import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import { strTobase64, base64ToStr  } from "../../utils/base64Util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { faArrowTrendUp, faUserPen, faUserCheck, faClipboardCheck, faMagnifyingGlass, faDownload, faFileArrowDown, faEdit, faTrash, faFolderClosed } from "@fortawesome/free-solid-svg-icons";

import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";

import './SolicitacaoAdesaoArquivosGrandesVoumes.css';
import { 	SITUACAO_SOLICITACAO_RASCUNHO, SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA, SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE,
			SITUACAO_SOLICITACAO_REJEITADA_CEDENTE, SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA, SITUACAO_SOLICITACAO_DEFERIDA,
			SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA, SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA,
			ID_SITUACAO_SOLICITACAO_RASCUNHO, ID_SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA, 
 } from "../../providers/constSituacoesSolicitacao";

 import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const tipoVisaoConsumidor = 'C';
const tipoVisaoFornecedor = 'F';
const tipoVisaoOperador = 'O';
const tipoVisaoPontoFocal = 'P';

const todasSituacoes = [
	SITUACAO_SOLICITACAO_RASCUNHO,
	SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA,
	SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE,
	SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA,
	SITUACAO_SOLICITACAO_REJEITADA_CEDENTE,
	SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA,
	SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA,
	SITUACAO_SOLICITACAO_DEFERIDA
];

export const SolicitacaoAdesaoArquivosGrandesVolumesList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.initialState = {
				criterioPesquisa: {
					numero: '',
					orgao: '',
					orgaoConjuntoArquivo: '',
					situacao: '',
					conjuntoArquivo: '',
					tipoVisao: tipoVisaoConsumidor,
					esferaAdministrativa: '',
					mostraHistorico: false,
				},
				orgaos: [],
				orgaosFornecedores: [],
				situacoes: [...todasSituacoes],
				conjuntoArquivos: [],
				tiposVisao: [],
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				carregandoConjuntoArquivos: false,
				carregandoOrgaos: false,
				carregandoOrgaosFornecedores: false,
				carregandoTiposVisao: false,
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				botoesHabilitados : true,
				exibeModalConfirmacao: false,
				msgModal: '',
				operacao: null,
			};
			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleTipoVisaoChange = this.handleTipoVisaoChange.bind(this);
			this.handleOrgaoConjuntoArquivoChange = this.handleOrgaoConjuntoArquivoChange.bind(this);
			this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarConjuntoArquivos = this.carregarConjuntoArquivos.bind(this);
			this.carregaSituacoes = this.carregaSituacoes.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.excluirSolicitacao = this.excluirSolicitacao.bind(this);
			this.liberarSolicitacaoAssinatura = this.liberarSolicitacaoAssinatura.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Solicitações de Adesão a Arquivos de Grandes Volumes</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			
			const user = this.props.user;
			let tipoVisao = tipoVisaoConsumidor;

			this.setState({
				carregandoOrgaosFornecedores: true,
				tipoVisao,
			})

			api.get('/api/orgao/fornecedores-arquivo-gv')
				.then(response => { 
					this.setState({orgaosFornecedores: response.data}); 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os órgãos cedentes." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				}).finally(() => {
					this.setState({carregandoOrgaosFornecedores: false});
				});

			if(user.isAdministrador || user.isGestorAGV || user.isMantenedor || user.isPontoFocal){
				if(user.isGestorAGV || user.isPontoFocal){
					if (user.isPontoFocal) {
						tipoVisao = tipoVisaoPontoFocal;
					} else if(user.isGestorAGV){
						tipoVisao = tipoVisaoFornecedor;
					}

					const { criterioPesquisa } = this.state;
					criterioPesquisa.tipoVisao = tipoVisao;
					this.setState({ carregandoTiposVisao: true, criterioPesquisa });
					api.get('/api/consumo/tipos-visao-relatorio')
					.then(response => { 
						const tiposVisao = response.data.filter(tv => tv.codigo !== tipoVisaoOperador);
						this.setState({tiposVisao}) 
					})
					.catch(erro => {
						console.log("Não foi possível recuperar os tipos de visão para a consulta.", erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					}).finally(() => {
						this.setState({carregandoTiposVisao: false});
					});
				}
				this.carregarOrgaos(tipoVisao);
			}
			
			this.carregaSituacoes(tipoVisao);
			this.carregarConjuntoArquivos(tipoVisao, '');

			if (localStorage.getItem('stateParent') && 
				localStorage.getItem('stateParentUrl') && 
				localStorage.getItem('stateParentUrl') === this.props.location.pathname) {
				const stateParent = JSON.parse(base64ToStr(localStorage.getItem('stateParent')));
				localStorage.removeItem('stateParent');
				localStorage.removeItem('stateParentUrl');
				this.executarPesquisaAnterior(stateParent);
			} else if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const user = this.props.user;

			const { 
				criterioPesquisa, resultadoPesquisa, pesquisaExecutada, orgaos, orgaosFornecedores, 
				situacoes, conjuntoArquivos, carregandoOrgaos, carregandoOrgaosFornecedores,
				carregandoConjuntoArquivos, carregandoTiposVisao
			} = this.state;
			const { content } = resultadoPesquisa;
			const exibeBotoes = content && content.length > 0;
			const { numero, orgao, orgaoConjuntoArquivo, situacao, conjuntoArquivo, tipoVisao, esferaAdministrativa, mostraHistorico } = criterioPesquisa;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={() => this.fechaModal()}
						message={this.state.msgModal}/>

					<div className="br-form">
						{user && (user.isGestorAGV === true || user.isPontoFocal === true) &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="tipoVisao">Mostrar:</label>
											{carregandoTiposVisao === false &&
												<SelectSearch
													id="tipoVisao"
													name="tipoVisao"
													options={this.state.tiposVisao.map(tipoVisao => ({ value: tipoVisao.codigo, label: tipoVisao.nomeConsultaSolicitacaoAdesao }))}
													onChange={this.handleTipoVisaoChange}
													value={tipoVisao}
												/>
											}
											{ carregandoTiposVisao === true  && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							</div>
						}
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Número solicitação:</label>
										<input type="text" name="numero" 
											value={numero}  
											onChange={this.handleInputChange} maxLength={11}/>
										
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Situação:</label>
										<SelectSearch
											id="situacao"
											name="situacao"
											options={situacoes.map(situacao => ({ value: situacao.id, label: situacao.nome }))}
											includeAllOption={true}
											allOptionName="Todas"
											onChange={this.handleInputChange}
											value={situacao}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							{(user.isAdministrador || user.isMantenedor || (user.isGestorAGV && tipoVisao === tipoVisaoFornecedor) || (user.isPontoFocal && tipoVisao === tipoVisaoPontoFocal)) &&
								<>
									<div className="col-sd">
										<div className="field">
											<div className="input">
												<label>Esfera Administrativa:</label>
												<SelectSearch
													id="esferaAdministrativa"
													name="esferaAdministrativa"
													allOptionName="Todas"
													options={this.state.esferasAdministrativas.map(esfera => ({ value: esfera.codigo, label: esfera.nome }))}
													includeAllOption={true}
													onChange={this.handleEsferaAdministrativaChange}
													value={esferaAdministrativa}
												/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Órgão solicitante:</label>
												{ carregandoOrgaos === false && orgaos.length > 0 &&
													<SelectSearch
														id="orgao"
														name="orgao"
														options={orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
														includeAllOption={true}
														onChange={this.handleInputChange}
														value={orgao}
													/>
												}
												{ carregandoOrgaos === false && orgaos.length === 0 &&
													<p>Nenhum órgão encontrado.</p>
												}
												{ carregandoOrgaos === true  && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}
											</div>
										</div>
									</div>
								</>
							}
							{(!(user.isGestorAGV && tipoVisao === tipoVisaoFornecedor)) &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Órgão cedente dos dados:</label>
											{ carregandoOrgaosFornecedores === false  && 
												<SelectSearch
													id="orgaoConjuntoArquivo"
													name="orgaoConjuntoArquivo"
													options={orgaosFornecedores.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
													includeAllOption={true}
													onChange={this.handleOrgaoConjuntoArquivoChange}
													value={orgaoConjuntoArquivo}
												/>
											}
											{ carregandoOrgaosFornecedores === true  && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							}
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Conjunto de Arquivos:</label>
										{ carregandoConjuntoArquivos === false  && 
										<SelectSearch
												id="conjuntoArquivo"
												name="conjuntoArquivo"
												options={conjuntoArquivos.map(conjuntoArquivo => ({ value: conjuntoArquivo.id, label: conjuntoArquivo.titulo + " (" + conjuntoArquivo.nomeOrgao + ")" }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={conjuntoArquivo}
											/>
										}
										{ carregandoConjuntoArquivos === true  && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm">
								<div className="check">
									<div className="input">
										<input type="checkbox" name="mostraHistorico" checked={mostraHistorico} onChange={this.handleInputChange} />
										<label>Mostrar histórico da solicitação no relatório CSV</label>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								{user.isCliente &&
									<Link to="/solicitacao-adesao-arquivo-gv/new"> 
										<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Nova</button>
									</Link>
								}	
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Número</th>
												<th scope="col">Órgão solicitante</th>
												<th scope="col">Órgão cedente</th>
												<th scope="col">Conjunto de Arquivos</th>
												<th scope="col">Arquivos</th>
												<th scope="col">Situação</th>
												<th scope="col">Último andamento</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((solicitacao, index) =>
													<tr key={index} >
														<td>{solicitacao.numero}</td>
														<td>{solicitacao.nomeOrgao}</td>
														<td>{solicitacao.nomeOrgaoConjuntoArquivo}</td>
														<td>{solicitacao.tituloConjuntoArquivo}</td>
														<td>{solicitacao.nomesArquivosOperacao}</td>
														<td>{solicitacao.nomeSituacao}</td>
														<td>{solicitacao.dataUltimoAndamento}</td>
														<td className="text-center">
															<div className="actions">
																{ solicitacao.exclusaoPermitida &&
																	<button type="button" onClick={() => this.confirmaOperacao(solicitacao, this.excluirSolicitacao, "Deseja realmente excluir a solicitação de adesão a arquivos de grandes volumes?")} 
																			disabled={!this.state.botoesHabilitados}  
																			title="Excluir a solicitação de adesão a arquivos de grandes volumes">
																		<span className="sr-only">Excluir</span>
																		<FontAwesomeIcon icon={faTrash} id="danger" />
																	</button>
																}

																{ solicitacao.alteracaoPermitida &&
																	<Link to={`/solicitacao-adesao-arquivo-gv/edit/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Editar a solicitação de adesão a arquivos de grandes volumes">
																			<span className="sr-only">Editar</span>
																			<FontAwesomeIcon icon={faEdit} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.liberacaoAssinaturaPermitida &&
																	<button type="button" onClick={() => this.confirmaOperacao(solicitacao, this.liberarSolicitacaoAssinatura, "Deseja realmente liberar a solicitação de adesão a arquivos de grandes volumes para assinatura?<br/><br/>Certifique-se de que o campo Finalidade está preenchido corretamente, seguindo as instruções disponíveis na seção de ajuda desse campo. Caso contrário, sua solicitação <b>poderá ser recusada</b>.")}  
																			disabled={!this.state.botoesHabilitados}  
																			title="Liberar a solicitação de adesão a arquivos de grandes volumes para assinatura">
																		<span className="sr-only">Liberar para assinatura</span>
																		<FontAwesomeIcon icon={faArrowTrendUp} style={{color: "#1351b4"}} />
																	</button>
																}

																{ solicitacao.assinaturaPermitida &&
																	<button type="button"
																			onClick={() => this.handleState(solicitacao.id)} 
																			disabled={!this.state.botoesHabilitados}  
																			title="Assinar a solicitação de adesão a arquivos de grandes volumes">
																		<span className="sr-only">Assinar solicitação de adesão a arquivos de grandes volumes</span>
																		<FontAwesomeIcon icon={faUserPen} style={{color: "#1351b4"}} />
																	</button>
																	
																}

																{ solicitacao.aprovacaoFornecedoraPermitida &&
																	<Link to={`/solicitacao-adesao-arquivo-gv/approve/${solicitacao.id}`}>
																		<button type="button" 
																				disabled={!this.state.botoesHabilitados}  
																				title="Aprovar ou rejeitar a solicitação de adesão a arquivos de grandes volumes">
																			<span className="sr-only">Aprovar ou rejeitar solicitação de adesão a arquivos de grandes volumes</span>
																			<FontAwesomeIcon icon={faClipboardCheck} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.aprovacaoAdministradorPermitida &&
																	<Link to={`/solicitacao-adesao-arquivo-gv/approve/${solicitacao.id}`}>
																		<button type="button" 
																				disabled={!this.state.botoesHabilitados}  
																				title="Deferir a solicitação de adesão a arquivos de grandes volumes">
																			<span className="sr-only">Deferir solicitação de adesão a arquivos de grandes volumes</span>
																			<FontAwesomeIcon icon={faUserCheck} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.configuracaoPastaSeguraPermitida &&
																	<Link to={`/solicitacao-adesao-arquivo-gv/pasta-segura/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Registrar informações de configuração da Pasta Segura">
																			<span className="sr-only">Registrar informações de configuração da Pasta Segura</span>
																			<FontAwesomeIcon icon={faFolderClosed} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}

																{ solicitacao.visualizacaoDAIPermitida &&
																	<button type="button" onClick={() => this.baixarDAIPDF(solicitacao.id)}  
																			disabled={!this.state.botoesHabilitados}  
																			title="Baixar o documento de autorização de interoperabilidade">
																		<span className="sr-only">Baixar o documento de autorização de interoperabilidade</span>
																		<FontAwesomeIcon icon={faFileArrowDown} style={{color: "#1351b4"}} />
																	</button>
																}

																{ solicitacao.visualizacaoTermoAdesaoPermitida &&
																	<button type="button" onClick={() => this.baixarTermoAdesaoPDF(solicitacao.id)}  
																			disabled={!this.state.botoesHabilitados}  
																			title="Baixar o termo de adesão a arquivos de grandes volumes">
																		<span className="sr-only">Baixar o termo de adesão a arquivos de grandes volumes</span>
																		<FontAwesomeIcon icon={faDownload} style={{color: "#1351b4"}} />
																	</button>
																}

																{ solicitacao.visualizacaoPermitida &&
																	<Link to={`/solicitacao-adesao-arquivo-gv/view/${solicitacao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Visualizar a solicitação de adesão a arquivos de grandes volumes">
																			<span className="sr-only">Visualizar</span>
																			<FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
																		</button>
																	</Link>
																}
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma solicitação encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleState(solicitacaoId) {
			const stateFilters = {
				criterioPesquisa: this.state.criterioPesquisa
			}
			const stateParent = strTobase64(JSON.stringify(stateFilters));
			localStorage.setItem('stateParentUrl', this.props.location.pathname);
			console.log(`Tamanho aproximado: ${stateParent.length * 2} bytes`); // Exemplo: 38 bytes
			localStorage.setItem('stateParent', stateParent);
			this.props.history.push(`/solicitacao-adesao-arquivo-gv/sign/${solicitacaoId}`)
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState({ criterioPesquisa });
		}

		handleTipoVisaoChange(evento){
			const tipoVisao =  evento.target.value;
			const esferaAdministrativa = '';
			const orgao = '';

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.tipoVisao = tipoVisao;
			criterioPesquisa.esferaAdministrativa = esferaAdministrativa;	
			criterioPesquisa.orgao = orgao;
			criterioPesquisa.orgaoConjuntoArquivo= '';
			criterioPesquisa.conjuntoArquivo = '';
			criterioPesquisa.situacao = '';
			this.setState({ criterioPesquisa });
			
			this.carregarOrgaos(tipoVisao, esferaAdministrativa);
			this.carregaSituacoes(tipoVisao);
			this.carregarConjuntoArquivos(tipoVisao, orgao);
		}

		handleOrgaoConjuntoArquivoChange(evento){
			const orgaoConjuntoArquivo =  evento.target.value;
			const tipoVisao = this.state.criterioPesquisa.tipoVisao;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.orgaoConjuntoArquivo = orgaoConjuntoArquivo;
			criterioPesquisa.conjuntoArquivo = '';
			this.setState({ criterioPesquisa });

			this.carregarConjuntoArquivos(tipoVisao, orgaoConjuntoArquivo);
		}

		handleEsferaAdministrativaChange(evento){
			const esferaAdministrativa =  evento.target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa.esferaAdministrativa = esferaAdministrativa;
			this.setState({ criterioPesquisa });

			this.carregarOrgaos(criterioPesquisa.tipoVisao, esferaAdministrativa);
		}

		carregarOrgaos(tipoVisao, esferaAdministrativa) {
			this.setState({carregandoOrgaos: true})
			const user = this.props.user;
			let url = '/api/orgao/clientes?ativos=true';
			
			if (esferaAdministrativa) {
				url += `&esferasAdministrativas=${[esferaAdministrativa]}`;
			}

			if( user.isPontoFocal && tipoVisao === tipoVisaoPontoFocal){
				url += '&pontoFocal=true';
			}

			api.get(url)
				.then(response => { 
					this.setState({orgaos: response.data }); 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoOrgaos: false});
				});
		}

		carregarConjuntoArquivos(idTipoVisao, idOrgao) {
			this.setState({carregandoFornecedoras : true});

			api.get(`/api/conjunto-arquivo-gv/disponivel-adesao-orgao/tipo-visao/${idTipoVisao}/orgao-fornecedor?idOrgaoFornecedor=${idOrgao}`)
				.then(response => { 
					this.setState({conjuntoArquivos: response.data})
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os conjuntos de arquivos " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				})
				.finally(() => {
					this.setState({carregandoFornecedoras: false})
				});
		}

		carregaSituacoes(idTipoVisao){
			const user = this.props.user;
			let situacoes = [...todasSituacoes];
			if(user.isMantenedor || (user.isGestorAGV && idTipoVisao === tipoVisaoFornecedor)){
				situacoes = situacoes.filter(s => s.id !== ID_SITUACAO_SOLICITACAO_RASCUNHO && s.id !== ID_SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA);
			}
			this.setState({situacoes});
		}

		executarPesquisaAnterior(state) {
			const lastState = state ?? this.props.filters[this.props.location.pathname];

			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const previousPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(previousPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){
			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/solicitacao-adesao-arquivo-gv/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as solicitações de adesão a arquivos de grandes volumes. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			const user = this.props.user;
			const tipoVisao = user.isPontoFocal ? tipoVisaoPontoFocal : user.isFornecedor ? tipoVisaoFornecedor : tipoVisaoConsumidor;
			this.carregaSituacoes(tipoVisao);
			const orgao = '';
			this.setState(
				{
					criterioPesquisa: {
						numero: '',
						orgao,
						orgaoConjuntoArquivo: '',
						situacao: '',
						conjuntoArquivo: '',
						tipoVisao,
						mostraHistorico: false,
					},
					resultadoPesquisa: {},
					pesquisaExecutada: false,
					exibeModalConfirmacao: false,
					botoesHabilitados : true,
				}, () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			)
			this.carregarConjuntoArquivos(tipoVisao, orgao);
		}

		confirmaOperacao(solicitacao, operacao, msgModal) {
			this.setState(
				{
					exibeModalConfirmacao: true,
					solicitacaoAlvo: solicitacao,
					operacao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao(this.state.solicitacaoAlvo);
			this.fechaModal();
		}

		excluirSolicitacao (solicitacao){
			api.delete(`/api/solicitacao-adesao-arquivo-gv/${solicitacao.id}`)
				.then(response => { 
					this.setState({
						pesquisaExecutada : true,
					}) 
					this.pesquisar();
					this.props.exibeMensagemSucesso("Solicitação de adesão a arquivos de grandes volumes excluída com sucesso.");
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir a solicitação de adesão a arquivos de grandes volumes.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		liberarSolicitacaoAssinatura (solicitacao){
			api.put(`/api/solicitacao-adesao-arquivo-gv/liberar-assinatura/${solicitacao.id}`)
				.then(response => { 
					this.setState({
						pesquisaExecutada : true,
					}) 
					this.pesquisar();
					this.props.exibeMensagemSucesso("Solicitação de adesão a arquivos de grandes volumes liberada para assinatura com sucesso.");
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível liberar a solicitação de adesão para assinatura.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		fechaModal () {
			this.setState(
				{
					exibeModalConfirmacao: false,
				}
			);
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const { criterioPesquisa } = this.state;
			const url = `/api/solicitacao-adesao-arquivo-gv/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioSolicitacoesAdesoesArquivoGV.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de solicitações de adesão a arquivos de grandes volumes';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		baixarTermoAdesaoPDF(id){
            const options = {
				method: 'post',
				url: `/api/solicitacao-adesao-arquivo-gv/termo-adesao/pdf/${id}`,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({ botoesHabilitados : false });

			api(options)
				.then((response) => {
                    let nomeArquivo = 'TermoAdesaoArquivoGV.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeArquivo = contentDisposition.split("filename=")[1];
					}

                    baixarArquivo(new Blob([response.data]), nomeArquivo);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o termo de adesão a arquivos de grandes volumes';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		baixarDAIPDF(id){
            const options = {
				method: 'post',
				url: `/api/solicitacao-adesao-arquivo-gv/dai/pdf/${id}`,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({ botoesHabilitados : false });

			api(options)
				.then((response) => {
                    let nomeArquivo = 'DocumentoAutorizacaoInteroperabilidade.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeArquivo = contentDisposition.split("filename=")[1];
					}

                    baixarArquivo(new Blob([response.data]), nomeArquivo);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o documento de autorizacao de interoperabilidade';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}
	}

) // redux
); // router